import { render, staticRenderFns } from "./sendCode.vue?vue&type=template&id=0fa43735&scoped=true&"
import script from "./sendCode.vue?vue&type=script&lang=js&"
export * from "./sendCode.vue?vue&type=script&lang=js&"
import style0 from "./sendCode.vue?vue&type=style&index=0&id=0fa43735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa43735",
  null
  
)

export default component.exports